import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveComponentModule } from '@ngrx/component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OmniSharedUiModule } from '@cigna/omni/shared';
import { OmniChatStateModule } from '@cigna/omni/chat-state';
import { OmniConversationsStateModule } from '@cigna/omni/conversations-state';
import { OmniMessagingCtaComponent } from './cta/cta.component';
import { OmniMessagingDataComponent } from './data/data.component';
import { OmniMessagingContentLinkComponent } from './content-link/content-link.component';
import { OmniMessagingDataListComponent } from './data-list/data-list.component';
import { OmniMessagingDataTableComponent } from './data-table/data-table.component';
import { OmniMessagingLinkTextComponent } from './link-text/link-text.component';
import { OmniMessagingDateChangeComponent } from './date-change/date-change.component';
import { MessagingFacade } from './facade/messaging.facade';
import { OmniMessagingInputComponent } from './input/input.component';
import { OmniMessagingItemComponent } from './item/item.component';
import { OmniMessagingListComponent } from './list/list.component';
import { OmniMessagingOutroComponent } from './outro/outro.component';
import { OmniMessagingSystemEventComponent } from './system-event/system-event.component';
import { OmniMessagingSystemGeneratedMessageComponent } from './system-generated-message/system-generated-message.component';
import { OmniMessagingWaitTimeComponent } from './wait-time/wait-time.component';
import { UiAccordionModule } from '@cigna/ui/accordion';
import { UiButtonModule } from '@cigna/ui/button';
import { CdnPrefixPipe } from './pipes/cdn-prefix.pipe';
import { HtmlDecodePipe } from './pipes/html-decode.pipe';
import { LinkTextPipe } from './pipes/link-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { HrefToRouterLinkDirective } from './directives/href-to-routerlink.directive';
import { UiIconModule } from '@cigna/ui/icon';
import { OmniMessagingSplashCloseScreenComponent } from './chat-splash-close-screen/chat-splash-close-screen.component';
import { OmniMessagingDisclaimerComponent } from './disclaimer/disclaimer.component';
import { AvatarComponent } from './avatar/avatar.component';
import { OmniMessagingAfterHoursChatComponent } from './after-hours-chat/after-hours-chat.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    OmniChatStateModule,
    ReactiveComponentModule,
    OmniConversationsStateModule,
    ReactiveFormsModule,
    UiAccordionModule,
    UiButtonModule,
    OmniSharedUiModule,
    UiIconModule,
  ],
  exports: [OmniMessagingDataComponent],
  declarations: [
    OmniMessagingCtaComponent,
    OmniMessagingDataComponent,
    OmniMessagingContentLinkComponent,
    OmniMessagingDataListComponent,
    OmniMessagingDataTableComponent,
    OmniMessagingLinkTextComponent,
    OmniMessagingDateChangeComponent,
    OmniMessagingInputComponent,
    OmniMessagingItemComponent,
    OmniMessagingListComponent,
    OmniMessagingOutroComponent,
    OmniMessagingSystemEventComponent,
    OmniMessagingSystemGeneratedMessageComponent,
    OmniMessagingWaitTimeComponent,
    OmniMessagingSplashCloseScreenComponent,
    OmniMessagingDisclaimerComponent,
    AvatarComponent,
    OmniMessagingAfterHoursChatComponent,
    HtmlDecodePipe,
    LinkTextPipe,
    SafeHtmlPipe,
    HrefToRouterLinkDirective,
  ],
  providers: [MessagingFacade, CdnPrefixPipe],
})
export class OmniMessagingModule {}
